import {paySubscriptionByOneTimePayment} from './mutations/create-subscription-for-pay'
import {createSubscriptionRequestMutation} from './mutations/create-subscription-request'
import {paySubscriptionByTokenMutation} from './mutations/pay-subscription-by-token.mutation'
import {validateUserSubscriptionsMutation} from './mutations/validate-user-subscriptions'
import {getSubscriptionQuery} from './queries/get-subscription-entity'

export const SubscriptionsQueries = {
  getSubscriptionQuery,
  createSubscriptionRequestMutation,
  validateUserSubscriptionsMutation,
}

export const SubscriptionsMutations = {
  paySubscriptionByTokenMutation,
  paySubscriptionByOneTimePayment
}
